<div class="flex w-full flex-col justify-start gap-3 xs:gap-4 sm:gap-6 lg:gap-8">
  <div>
    <h4
      class="is-heading break-long-words is-xs group flex items-end font-heading text-sm font-medium group-[.is-box]:mt-0 xs:text-base sm:text-base lg:text-base">
      {{ 'reset-requested.requested-email.label' | translate }}
    </h4>
    {{ email }}
  </div>
  <div class="rounded-xl rounded-tl-none bg-informative-5 p-3 text-informative-150 xs:p-4">
    <div class="flex items-center gap-2 font-heading text-sm font-medium lg:text-base">
      <pay-icon [shape]="IconNames.Information" [size]="'sm'" />
      <span class="leading-5">{{ 'reset-requested.information.label' | translate }}</span>
    </div>
    <div class="py-2 text-xs text-neutral-100 lg:text-sm">
      {{ 'reset-requested.information.description' | translate }}
    </div>
  </div>
  <a
    type="submit"
    class="font-body font-sm focus-visible:secondary-5 group relative box-border flex w-full flex-row justify-center gap-x-2.5 rounded-xl border-2 border-primary-100 px-6 py-4 font-semibold text-neutral-100 no-underline ring-secondary-20 transition-colors hover:border-primary-130 hover:text-primary-130 focus-visible:border-primary-130 focus-visible:bg-secondary-5 focus-visible:text-primary-130 focus-visible:outline-none focus-visible:ring-8 enabled:hover:bg-secondary-5 disabled:cursor-not-allowed disabled:border-neutral-60 disabled:text-neutral-60 lg:w-auto"
    href="https://www.pay.nl/en/contact">
    <span class="order-last">
      <span class="flex h-6 w-6 items-center justify-center">
        <pay-icon [shape]="IconNames.Headset" [size]="'sm'" />
      </span>
    </span>
    <span>{{ 'reset-requested.contact-support.label' | translate }}</span>
  </a>
  <div class="text-center">
    <span role="button" tabindex="0" class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="returnToLogin()">
      {{ 'reset-requested.back-to-login.label' | translate }}
    </span>
  </div>
</div>
